import React from "react";
import { ToggleSwitch } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { STATUS_USER } from "../../constants/app";
import CustomSpan from "../CustomSpan";

const UserStatusToggle = ({ checked, handleChangeToggle, index, id , disabled }) => {
  return (
    <div className="flex items-center w-full">
      <CustomSpan
        className="inline-block mr-2"
        text="無効"
        onClick={() =>
          handleChangeToggle(index, "status", STATUS_USER.RESIGN, id)
        }
      />
      <ToggleSwitch
        theme={tenkenTheme}
        color="primary"
        checked={checked}
        onChange={() => handleChangeToggle(index, "status", !checked, id)}
        disabled={disabled}
      />
      <CustomSpan
        className="inline-block ml-2"
        text="有効"
        onClick={() =>
          handleChangeToggle(index, "status", STATUS_USER.ACTIVE, id)
        }
      />
    </div>
  );
};

export default UserStatusToggle;
